import Cookies from 'js-cookie';
import { callAPI } from '..';
import { apiPath } from '..';
import { getCookieToken } from '..';

const getPaymentInfo = async () => {

    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_PAYMENTINFO;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

//解除綁定
const callRemovePayment = async (password) => {

    try {
        const token = await getCookieToken();
        let headers = { 'Content-Type': 'application/json', 'token': token, 'password': password };

        const url = apiPath.GET_URL_REMOVEPAYMENT;
        const method = 'POST';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

//綁定信用卡
const callBindCreditCard = async (data) => {
    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_BIND_CREDIT_CARD;
        const method = 'POST';
        const response = await callAPI({ method, url, headers, data });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

//綁定Line
const callBindLinePay = async (data) => {

    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_BIND_LINE_PAY;
        const method = 'POST';
        const response = await callAPI({ method, url, headers, data });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

export { getPaymentInfo, callRemovePayment, callBindCreditCard, callBindLinePay };